import React, { useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import AdminHeader from "../Header/AdminHeader";
import AdminFooter from "../Footer/AdminFooter";
import AdminLeftMenu from "../Navbar/AdminLeftMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import api from "../../axios/Axios";
import { faChevronDown, faChevronRight } from "@fortawesome/free-solid-svg-icons";


const AddEmployee = () => {
  const history = useHistory();

  const [userId, setUserId] = useState("");
  const [userToken, setUserToken] = useState("");
  const [isAdmin, setIsAdmin] = useState("");
  const [empName, setEmpName] = useState("");
  const [employeeType, setEmployeeType] = useState(isAdmin === "admin" ? "" : "reseller");
  const [empEmail, setEmpEmail] = useState("");
  const [empPhone, setEmpPhone] = useState("");
  const [empPassword, setEmpPassword] = useState("");
  const [cnfmPassword, setCnfmPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [eyeIconToggle, setEyeIconToggle] = useState(false);
  const [passError, setPassError] = useState(0);
  const [currency, setCurrency] = useState("");
  const [userDetails, setUserDetails] = useState({})
  const [checkBox, setCheckBox] = useState({
    all: 0,
    sms: 0,
    voice: 0,
    email: 0,
    whatsapp: 0,
    recharge: 0,
    notification: 0,
    rich_media: 0,
    fallback: 0,
    rcs: 0,
    chat: 0,
    flow: 0
  })
  const [permissionCheckBox, setPermissionCheckBox] = useState({
    all: false,
    usermanagement: false,
    userlist: false,
    userlistall: false,
    addnewclient: false,
    assignplan: false,
    empreseller: false,
    addeditprice: false,
    addeditcredit: false,
    transactiondetails: false,
    awssetting: false,
    billingmode: false,
    entitybypass: false,
    changecurrency: false,
    bulksmsroutesetting: false,
    autoshorturl: false,
    extrasetting: false,
    mmlite: false,
    routemanagement: false,
    routelist: false,
    routelistall: false,
    shiftrouter: false,
    changeroute: false,
    lcrroutesetting: false,
    embededsignup: false,
    read: false,
    edit: false,
    report: false,
    readreport: false,
    download: false,
    allreport: false,
    affiliatemanagement: false,
    affiliateuser: false,
    affiliatecommonlist: false,
    useractivity: false,
    loginhistory: false,
    signuphistory: false,
    entityhistory: false,
    sendorhistory: false,
    templatehistory: false,
    awssetuphistory: false,
    apirequest: false,
    invalidapirequest: false,
    setting: false,
    resellersetting: false,
    billingreport: false,
    billingreportall: false,
    vendorsummary: false,
    encryptionsetting: false,
    notificationsetting: false,
    crossorigin: false,
    addfaq: false,
    blog: false,
    feedback: false,
    contactus: false,
  });

  const [openMenu, setOpenMenu] = useState({});

  // console.log(permissionCheckBox);


  const toggleMenu = (index) => {
    setOpenMenu((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  useEffect(() => {
    const lStorage = JSON.parse(localStorage.getItem("admin") || localStorage.getItem("emp") || localStorage.getItem("reseller"));
    if (lStorage) {
      setUserId(lStorage.user.userId);
      setUserToken(lStorage.token);
      setIsAdmin(lStorage.user.isAdmin);
      setUserDetails(lStorage.user)
    }
  }, []);

  const buildSubAdminPayload = (permissionCheckBox) => {
    return {
      role: "sub_admin",
      fullAccess: permissionCheckBox.all || false,
      permissions: {

        usermanagement: {
          enabled: permissionCheckBox.usermanagement,
          children: {
            userlist: permissionCheckBox.userlist,
            userlistall: permissionCheckBox.userlistall,
            addnewclient: permissionCheckBox.addnewclient,
            assignplan: permissionCheckBox.assignplan,
            employeereseller: permissionCheckBox.empreseller,
            addeditprice: permissionCheckBox.addeditprice,
            addeditcredit: permissionCheckBox.addeditcredit,
            transactiondetails: permissionCheckBox.transactiondetails,
            awssettings: permissionCheckBox.awssetting,
            billingmode: permissionCheckBox.billingmode,
            entitybypass: permissionCheckBox.entitybypass,
            changecurrency: permissionCheckBox.changecurrency,
            bulksmsroutesetting: permissionCheckBox.bulksmsroutesetting,
            autoshorturl: permissionCheckBox.autoshorturl,
            extrasettings: permissionCheckBox.extrasetting,
            mmlite: permissionCheckBox.mmlite
          }
        },

        routemanagement: {
          enabled: permissionCheckBox.routemanagement,
          children: {
            routelist: permissionCheckBox.routelist,
            routelistall: permissionCheckBox.routelistall,
            shiftrouter: permissionCheckBox.shiftrouter,
            changeroute: permissionCheckBox.changeroute,
            lcrroutesetting: permissionCheckBox.lcrroutesetting
          }
        },

        embeddedsignup: {
          enabled: permissionCheckBox.embededsignup,
          children: {
            read: permissionCheckBox.read,
            edit: permissionCheckBox.edit
          }
        },

        report: {
          enabled: permissionCheckBox.report,
          children: {
            read: permissionCheckBox.readreport,
            download: permissionCheckBox.download,
            allreport: permissionCheckBox.allreport
          }
        },

        affiliatemanagement: {
          enabled: permissionCheckBox.affiliatemanagement,
          children: {
            affiliateusers: permissionCheckBox.affiliateuser,
            affiliatecommonlist: permissionCheckBox.affiliatecommonlist
          }
        },

        useractivity: {
          enabled: permissionCheckBox.useractivity,
          children: {
            loginhistory: permissionCheckBox.loginhistory,
            signuphistory: permissionCheckBox.signuphistory,
            entityhistory: permissionCheckBox.entityhistory,
            sendorhistory: permissionCheckBox.sendorhistory,
            templatehistory: permissionCheckBox.templatehistory,
            awssetuphistory: permissionCheckBox.awssetuphistory,
            apirequest: permissionCheckBox.apirequest,
            invalidapirequest: permissionCheckBox.invalidapirequest
          }
        },

        setting: {
          enabled: permissionCheckBox.setting,
          children: {
            resellersetting: permissionCheckBox.resellersetting
          }
        },

        billingreport: permissionCheckBox.billingreport,
        billingreportall: permissionCheckBox.billingreportall,
        vendorsummary: permissionCheckBox.vendorsummary,
        encryptionsetting: permissionCheckBox.encryptionsetting,
        notificationsetting: permissionCheckBox.notificationsetting,
        crossorigin: permissionCheckBox.crossorigin,
        addfaq: permissionCheckBox.addfaq,
        blog: permissionCheckBox.blog,
        feedback: permissionCheckBox.feedback,
        contactus: permissionCheckBox.contactus
      }
    };
  };

  const addNewEmployee = async () => {
    document.querySelector("body").scrollTo(0, 0);
    const subAdminPermission = buildSubAdminPayload(permissionCheckBox);

    setSuccessMessage(false);
    setBgColor("");
    setErrorMessage("");

    // Validation
    if (!empName) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Please enter name");
      return;
    }

    if (!empPhone) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Please enter mobile no.");
      return;
    }

    if (!empEmail) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Please enter email");
      return;
    }

    if (!employeeType) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Please select employee type");
      return;
    }

    if (!empPassword) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Please enter password");
      return;
    }

    if (empPassword !== cnfmPassword) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("The passwords you entered don't match");
      return;
    }

    // Base Payload
    let createUserData = {
      user_id: userId,
      token: userToken,
      type: isAdmin,
      fullname: empName,
      employee_type: employeeType,
      mobile: empPhone,
      email: empEmail,
      password: empPassword,
      currency: currency,
      sms_menu: checkBox.sms,
      voice_menu: checkBox.voice,
      email_menu: checkBox.email,
      whatsapp_menu: checkBox.whatsapp,
      rechrg_menu: checkBox.recharge,
      notify_menu: checkBox.notification,
      rich_menu: checkBox.rich_media,
      fb_menu: checkBox.fallback,
      rcs_menu: checkBox.rcs,
      chat_menu: checkBox.chat,
      flow_menu: checkBox.flow,
      method: "add",
    };

    // Add subadmin permissions if needed
    if (employeeType === "subadmin") {
      createUserData.permissionValue = subAdminPermission;
    }

    try {
      const { data } = await api.post("/api/employee_user_list.php", createUserData);

      if (data.success === true) {
        setSuccessMessage(true);
        setBgColor("alert alert-success alert-dismissible");
        setErrorMessage(data.message);

        setTimeout(() => {
          history.push("/admin/employee-management");
        }, 2000);
      } else {
        setSuccessMessage(true);
        setBgColor("alert alert-danger alert-dismissible");
        setErrorMessage(data.message);
      }
    } catch (error) {
      setSuccessMessage(true);
      setBgColor("alert alert-danger alert-dismissible");
      setErrorMessage("Something went wrong. Please try again.");
      console.error(error);
    }
  };

  const handleCheckbox = (e) => {

    const { name, checked } = e.target;
    setCheckBox(prevState => ({
      ...prevState,
      [name]: checked ? 1 : 0,
    }));

    if (checkBox.sms === 1 && checkBox.voice === 1 && checkBox.email === 1 && checkBox.whatsapp === 1 && checkBox.recharge === 1 && checkBox.notification === 1 && checkBox.rich_media === 1 && checkBox.fallback === 1 && checkBox.rcs === 1 && checkBox.chat === 1 && checkBox.flow === 1 && checked === true) {
      setCheckBox(prevState => ({
        ...prevState,
        all: 1,
      }));
    } else {
      setCheckBox(prevState => ({
        ...prevState,
        all: 0,
      }));


    }

    if (checkBox.all === 1 && checked === false) {
      setCheckBox(prevState => ({
        ...prevState,
        all: 0,
      }));
    }




  }
  const handleCheckboxAll = (e) => {
    // e.preventdefault();

    const value = e.target.checked;
    let val;
    if (value === true) {
      val = 1;
    } else {
      val = 0;
    }
    setCheckBox({
      all: val,
      sms: val,
      voice: val,
      email: val,
      whatsapp: val,
      recharge: val,
      notification: val,
      rich_media: val,
      fallback: val,
      rcs: val,
      chat: val,
      flow: val
    })

  }

  const handlePermissionCheckbox = (e) => {

    const { name, checked } = e.target;
    setPermissionCheckBox(prevState => ({
      ...prevState,
      [name]: checked,
    }));

    if (permissionCheckBox.usermanagement &&
      permissionCheckBox.userlist &&
      permissionCheckBox.addnewclient &&
      permissionCheckBox.assignplan &&
      permissionCheckBox.empreseller &&
      permissionCheckBox.addeditprice &&
      permissionCheckBox.addeditcredit &&
      permissionCheckBox.transactiondetails &&
      permissionCheckBox.awssetting &&
      permissionCheckBox.billingmode &&
      permissionCheckBox.entitybypass &&
      permissionCheckBox.changecurrency &&
      permissionCheckBox.bulksmsroutesetting &&
      permissionCheckBox.autoshorturl &&
      permissionCheckBox.extrasetting &&
      permissionCheckBox.mmlite &&
      permissionCheckBox.routemanagement &&
      permissionCheckBox.routelist &&
      permissionCheckBox.shiftrouter &&
      permissionCheckBox.changeroute &&
      permissionCheckBox.lcrroutesetting &&
      permissionCheckBox.embededsignup &&
      permissionCheckBox.read &&
      permissionCheckBox.edit &&
      permissionCheckBox.report &&
      permissionCheckBox.readreport &&
      permissionCheckBox.download &&
      permissionCheckBox.allreport &&
      permissionCheckBox.affiliatemanagement &&
      permissionCheckBox.affiliateuser &&
      permissionCheckBox.affiliatecommonlist &&
      permissionCheckBox.useractivity &&
      permissionCheckBox.loginhistory &&
      permissionCheckBox.signuphistory &&
      permissionCheckBox.entityhistory &&
      permissionCheckBox.sendorhistory &&
      permissionCheckBox.templatehistory &&
      permissionCheckBox.awssetuphistory &&
      permissionCheckBox.apirequest &&
      permissionCheckBox.invalidapirequest &&
      permissionCheckBox.setting &&
      permissionCheckBox.resellersetting &&
      permissionCheckBox.billingreport &&
      permissionCheckBox.vendorsummary &&
      permissionCheckBox.encryptionsetting &&
      permissionCheckBox.notificationsetting &&
      permissionCheckBox.crossorigin &&
      permissionCheckBox.addfaq &&
      permissionCheckBox.blog &&
      permissionCheckBox.feedback &&
      permissionCheckBox.contactus && checked === true) {
      setPermissionCheckBox(prevState => ({
        ...prevState,
        all: true,
      }));
    } else {
      setPermissionCheckBox(prevState => ({
        ...prevState,
        all: false,
      }));


    }

    if (permissionCheckBox.all === 1 && checked === false) {
      setPermissionCheckBox(prevState => ({
        ...prevState,
        all: false,
      }));
    }
  }

  const handlePermissionCheckboxAll = (e) => {
    const Pervalue = e.target.checked;
    setPermissionCheckBox({
      all: Pervalue,
      usermanagement: Pervalue,
      userlist: Pervalue,
      addnewclient: Pervalue,
      assignplan: Pervalue,
      empreseller: Pervalue,
      addeditprice: Pervalue,
      addeditcredit: Pervalue,
      transactiondetails: Pervalue,
      awssetting: Pervalue,
      billingmode: Pervalue,
      entitybypass: Pervalue,
      changecurrency: Pervalue,
      bulksmsroutesetting: Pervalue,
      autoshorturl: Pervalue,
      extrasetting: Pervalue,
      mmlite: Pervalue,
      routemanagement: Pervalue,
      routelist: Pervalue,
      shiftrouter: Pervalue,
      changeroute: Pervalue,
      lcrroutesetting: Pervalue,
      embededsignup: Pervalue,
      read: Pervalue,
      edit: Pervalue,
      report: Pervalue,
      readreport: Pervalue,
      download: Pervalue,
      allreport: Pervalue,
      affiliatemanagement: Pervalue,
      affiliateuser: Pervalue,
      affiliatecommonlist: Pervalue,
      useractivity: Pervalue,
      loginhistory: Pervalue,
      signuphistory: Pervalue,
      entityhistory: Pervalue,
      sendorhistory: Pervalue,
      templatehistory: Pervalue,
      awssetuphistory: Pervalue,
      apirequest: Pervalue,
      invalidapirequest: Pervalue,
      setting: Pervalue,
      resellersetting: Pervalue,
      billingreport: Pervalue,
      vendorsummary: Pervalue,
      encryptionsetting: Pervalue,
      notificationsetting: Pervalue,
      crossorigin: Pervalue,
      addfaq: Pervalue,
      blog: Pervalue,
      feedback: Pervalue,
      contactus: Pervalue
    })
  }

  const handlePass = (e) => {
    setEmpPassword(e.target.value);


    if (e.target.value === "" && cnfmPassword === "")

      setPassError(0);


  }

  const handleCnfmPass = (e) => {

    if (e.target.value === "" && empPassword === "")
      setPassError(0);

    if (empPassword === "") {
      return;
    } else {
      setPassError(1);
    }
    const pass = empPassword;
    const cnfmPass = e.target.value;
    setCnfmPassword(e.target.value);
    if (pass === cnfmPass) {
      setPassError(0);
    } else {
      setPassError(1);
    }


  }


  const eyeToggle = (e) => {

    e.preventDefault();

    setEyeIconToggle(!eyeIconToggle);



  }

  return (
    <div className="wrapper">
      <AdminLeftMenu />
      <div className="main">
        <AdminHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div className="row">
              <div className="col-auto d-none d-sm-block">
                <h3>
                  {/* <strong>Add </strong> Employee{" "} */}
                  <strong>{isAdmin === "admin" ? "Add Employee" : "Add Reseller"}</strong>
                </h3>
              </div>
            </div>
            {successMessage ? (
              <div className={bgColor} role="alert">
                <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">{errorMessage}</div>
              </div>
            ) : null}
            <div className="row">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title mb-0">{isAdmin === "admin" ? "New Employee Details" : "New Reseller Details"}</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-12 col-lg-12 col-xxl-12 d-flex">
                      <div className=" flex-fill">
                        <form>

                          {/* ===== TOP FORM ===== */}
                          <div className="row">

                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Employee Type <span style={{ color: "red" }}>*</span>
                              </label>

                              <select
                                value={employeeType}
                                onChange={(e) => setEmployeeType(e.target.value)}
                                className="form-control"
                                style={{
                                  height: "42px",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd"
                                }}
                              >
                                <option value="">Choose Employee Type</option>
                                {isAdmin === "admin" &&
                                  (<>
                                    <option value="subadmin">Sub Admin</option>
                                    <option value="emp">Employee</option>
                                  </>)}
                                <option value="reseller">Reseller</option>
                              </select>
                            </div>

                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Full Name <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Full Name"
                                onChange={(e) => setEmpName(e.target.value)}
                                style={{
                                  height: "42px",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd"
                                }}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Email <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Enter Email ID"
                                onChange={(e) => setEmpEmail(e.target.value)}
                                style={{
                                  height: "42px",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd"
                                }}
                              />
                            </div>

                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Mobile Number <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                type="tel"
                                className="form-control"
                                value={empPhone}
                                onChange={(e) => setEmpPhone(e.target.value)}
                                placeholder="Enter Mobile Number"
                                style={{
                                  height: "42px",
                                  borderRadius: "8px",
                                  border: "1px solid #ddd"
                                }}
                              />
                            </div>

                            {/* Password */}
                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Password <span style={{ color: "red" }}>*</span>
                              </label>

                              <div style={{ position: "relative" }}>
                                <input
                                  type={eyeIconToggle ? "text" : "password"}
                                  value={empPassword}
                                  onChange={handlePass}
                                  className="form-control"
                                  placeholder="Enter Password"
                                  style={{
                                    height: "42px",
                                    borderRadius: "8px",
                                    border: "1px solid #ddd",
                                    paddingRight: "45px"
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={eyeToggle}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent"
                                  }}
                                >
                                  <FontAwesomeIcon icon={eyeIconToggle ? faEyeSlash : faEye} />
                                </button>
                              </div>
                            </div>

                            {/* Confirm Password */}
                            <div className="mb-3 col-md-6">
                              <label style={{ fontWeight: "500" }}>
                                Confirm Password <span style={{ color: "red" }}>*</span>
                              </label>

                              <div style={{ position: "relative" }}>
                                <input
                                  type={eyeIconToggle ? "text" : "password"}
                                  value={cnfmPassword}
                                  onChange={handleCnfmPass}
                                  className="form-control"
                                  placeholder="Enter Password"
                                  style={{
                                    height: "42px",
                                    borderRadius: "8px",
                                    border: "1px solid #ddd",
                                    paddingRight: "45px"
                                  }}
                                />
                                <button
                                  type="button"
                                  onClick={eyeToggle}
                                  style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    border: "none",
                                    background: "transparent"
                                  }}
                                >
                                  <FontAwesomeIcon icon={eyeIconToggle ? faEyeSlash : faEye} />
                                </button>
                              </div>
                            </div>

                          </div>

                          <div className="row">
                            
                            {(isAdmin === "admin" || isAdmin === "emp") && (
                              <div className="mb-3 col-md-6">
                                <label style={{ fontWeight: "500" }}>Currency</label>
                                <select
                                  value={currency}
                                  onChange={(e) => setCurrency(e.target.value)}
                                  className="form-control"
                                  style={{ height: "42px", borderRadius: "8px", border: "1px solid #ddd" }}
                                >
                                  <option value="">Select Currency</option>
                                  <option value="INR">INR</option>
                                  <option value="USD">USD</option>
                                  <option value="EUR">EUR</option>
                                </select>
                              </div>
                            )}

                          </div>
                          {/* ===== CHANNELS SECTION ===== */}
                          <div style={{ marginTop: "20px" }}>
                            <label style={{ fontWeight: "600" }}>
                              Channels
                              {/* <input type="checkbox" style={{ marginLeft: "10px" }} /> */}
                              <input
                                className="form-check-input cursor-pointer
                                  "
                                type="checkbox"
                                checked={
                                  checkBox.all === 1 ? true : false
                                }
                                style={{ marginLeft: "10px" }}
                                name="all"
                                value={checkBox.all}
                                onChange={handleCheckboxAll}
                              />
                            </label>

                            <div
                              style={{
                                border: "1px solid #e5e5e5",
                                borderRadius: "8px",
                                padding: "15px",
                                marginTop: "8px"
                              }}
                            >
                              <div className="row">

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.sms_menu === 1)) &&
                                  <div className="form-check ml-3 col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      checked={
                                        checkBox.sms === 1 ? true : false
                                      }
                                      name="sms"
                                      value={checkBox.sms}
                                      onChange={handleCheckbox}

                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      SMS
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.voice_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="voice"
                                      checked={
                                        checkBox.voice === 1
                                          ? true
                                          : false
                                      }
                                      value={checkBox.voice}
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Voice
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.email_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      value={checkBox.email}
                                      checked={
                                        checkBox.email === 1
                                          ? true
                                          : false
                                      }
                                      name="email"
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Email
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.whatsapp_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="whatsapp"
                                      value={checkBox.whatsapp}
                                      checked={
                                        checkBox.whatsapp === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Whatsapp
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.rechrg_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="recharge"
                                      value={checkBox.recharge}
                                      checked={
                                        checkBox.recharge === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Recharge
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.notify_menu === 1)) &&
                                  <div className="form-check ml-3 col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="notification"
                                      value={checkBox.notification}
                                      checked={
                                        checkBox.notification === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Notification
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.rich_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="rich_media"
                                      value={checkBox.rich_media}
                                      checked={
                                        checkBox.rich_media === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Rich Media
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.fb_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="fallback"
                                      value={checkBox.fallback}
                                      checked={
                                        checkBox.fallback === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Fallback
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.rcs_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="rcs"
                                      value={checkBox.rcs}
                                      checked={
                                        checkBox.rcs === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      RCS
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.chat_menu === 1)) &&
                                  <div className="form-check col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="chat"
                                      value={checkBox.chat}
                                      checked={
                                        checkBox.chat === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Chat
                                    </label>
                                  </div>}

                                {(isAdmin === "admin" || (isAdmin !== 'admin' && userDetails.flow_menu === 1)) &&
                                  <div className="form-check ml-3 col-md-2">
                                    <input
                                      className="form-check-input cursor-pointer
                                  "
                                      type="checkbox"
                                      name="flow"
                                      value={checkBox.flow}
                                      checked={
                                        checkBox.flow === 1
                                          ? true
                                          : false
                                      }
                                      onChange={handleCheckbox}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="flexCheckDefault"
                                    >
                                      Flow
                                    </label>
                                  </div>}

                                {/* repeat your other checkboxes here */}

                              </div>
                            </div>
                          </div>

                          {/* ===== SECOND BOX ===== */}
                          {/* ===== SECOND BOX ===== */}
                          {employeeType === "subadmin" &&
                            <div style={{ marginTop: "25px" }}>
                              <label style={{ fontWeight: "600" }}>
                                Some Heading
                                <input type="checkbox" style={{ marginLeft: "10px" }} value={permissionCheckBox.all}
                                  checked={permissionCheckBox.all}
                                  onChange={handlePermissionCheckboxAll} />
                              </label>

                              <div
                                style={{
                                  border: "1px solid #e5e5e5",
                                  borderRadius: "8px",
                                  padding: "15px",
                                  marginTop: "8px",
                                }}
                              >
                                <div className="row">

                                  {/* ===== BOX 1 ===== */}
                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input className="form-check-input" type="checkbox" name="usermanagement" value={permissionCheckBox.usermanagement}
                                        checked={permissionCheckBox.usermanagement}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[0] && permissionCheckBox.usermanagement) && "#F97316" }}
                                      >
                                        User Management
                                      </label>

                                      {permissionCheckBox.usermanagement &&
                                        <FontAwesomeIcon
                                          icon={openMenu[0] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(0)}
                                        />}
                                    </div>

                                    {(openMenu[0] && permissionCheckBox.usermanagement) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="userlist" value={permissionCheckBox.userlist}
                                            checked={permissionCheckBox.userlist}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">User List</label>
                                          {permissionCheckBox.userlist && <>
                                            <input className="form-check-input ml-4" type="checkbox" name="userlistall" value={permissionCheckBox.userlistall}
                                              checked={permissionCheckBox.userlistall}
                                              onChange={handlePermissionCheckbox} />
                                            <label className="form-check-label ml-5">All</label>
                                          </>}
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="addnewclient" value={permissionCheckBox.addnewclient}
                                            checked={permissionCheckBox.addnewclient}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Add New Client</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="assignplan" value={permissionCheckBox.assignplan}
                                            checked={permissionCheckBox.assignplan}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Assign Plan</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="empreseller" value={permissionCheckBox.empreseller}
                                            checked={permissionCheckBox.empreseller}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Employee/Reseller</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="addeditprice" value={permissionCheckBox.addeditprice}
                                            checked={permissionCheckBox.addeditprice}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Add/Edit Price</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="addeditcredit" value={permissionCheckBox.addeditcredit}
                                            checked={permissionCheckBox.addeditcredit}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Add/Edit Credit</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="transactiondetails" value={permissionCheckBox.transactiondetails}
                                            checked={permissionCheckBox.transactiondetails}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Transaction Details</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="awssetting" value={permissionCheckBox.awssetting}
                                            checked={permissionCheckBox.awssetting}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">AWS Settings</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="billingmode" value={permissionCheckBox.billingmode}
                                            checked={permissionCheckBox.billingmode}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Billing Mode</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="entitybypass" value={permissionCheckBox.entitybypass}
                                            checked={permissionCheckBox.entitybypass}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Entity By Pass</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="changecurrency" value={permissionCheckBox.changecurrency}
                                            checked={permissionCheckBox.changecurrency}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Change Currency</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="bulksmsroutesetting" value={permissionCheckBox.bulksmsroutesetting}
                                            checked={permissionCheckBox.bulksmsroutesetting}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Bulk SMS Route Setting</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="autoshorturl" value={permissionCheckBox.autoshorturl}
                                            checked={permissionCheckBox.autoshorturl}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Auto Short URL</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="extrasetting" value={permissionCheckBox.extrasetting}
                                            checked={permissionCheckBox.extrasetting}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Extra Settings</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="mmlite" value={permissionCheckBox.mmlite}
                                            checked={permissionCheckBox.mmlite}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">MMLite</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* ===== BOX 2 ===== */}
                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input className="form-check-input" type="checkbox" name="routemanagement" value={permissionCheckBox.routemanagement}
                                        checked={permissionCheckBox.routemanagement}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[1] && permissionCheckBox.routemanagement) && "#F97316" }}
                                      >
                                        Route Management
                                      </label>

                                      {permissionCheckBox.routemanagement &&
                                        <FontAwesomeIcon
                                          icon={openMenu[1] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(1)}
                                        />}
                                    </div>

                                    {(openMenu[1] && permissionCheckBox.routemanagement) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="routelist" value={permissionCheckBox.routelist}
                                            checked={permissionCheckBox.routelist}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Route List</label>
                                          {permissionCheckBox.routelist &&
                                            <>
                                              <input className="form-check-input ml-4" type="checkbox" name="routelistall" value={permissionCheckBox.routelistall}
                                                checked={permissionCheckBox.routelistall}
                                                onChange={handlePermissionCheckbox} />
                                              <label className="form-check-label ml-5">All</label>
                                            </>}
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="shiftrouter" value={permissionCheckBox.shiftrouter}
                                            checked={permissionCheckBox.shiftrouter}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Shift Router</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="changeroute" value={permissionCheckBox.changeroute}
                                            checked={permissionCheckBox.changeroute}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Change Route</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="lcrroutesetting" value={permissionCheckBox.lcrroutesetting}
                                            checked={permissionCheckBox.lcrroutesetting}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">LCR Route Setting</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* ===== BOX 3 ===== */}
                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input className="form-check-input" type="checkbox" name="embededsignup" value={permissionCheckBox.embededsignup}
                                        checked={permissionCheckBox.embededsignup}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[2] && permissionCheckBox.embededsignup) && "#F97316" }}
                                      >
                                        Embeded Signup
                                      </label>

                                      {permissionCheckBox.embededsignup &&
                                        <FontAwesomeIcon
                                          icon={openMenu[2] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(2)}
                                        />}
                                    </div>

                                    {(openMenu[2] && permissionCheckBox.embededsignup) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" name="read" type="checkbox" value={permissionCheckBox.read}
                                            checked={permissionCheckBox.read}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Read</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" name="edit" type="checkbox" value={permissionCheckBox.edit}
                                            checked={permissionCheckBox.edit}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Edit</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  {/* ===== BOX 4 ===== */}
                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input className="form-check-input" type="checkbox" name="report" value={permissionCheckBox.report}
                                        checked={permissionCheckBox.report}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[3] && permissionCheckBox.report) && "#F97316" }}
                                      >
                                        Report
                                      </label>

                                      {permissionCheckBox.report &&
                                        <FontAwesomeIcon
                                          icon={openMenu[3] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(3)}
                                        />}
                                    </div>

                                    {(openMenu[3] && permissionCheckBox.report) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="readreport" value={permissionCheckBox.readreport}
                                            checked={permissionCheckBox.readreport}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Read</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="download" value={permissionCheckBox.download}
                                            checked={permissionCheckBox.download}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Download</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="allreport" value={permissionCheckBox.allreport}
                                            checked={permissionCheckBox.allreport}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">All Reports</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                    >
                                      <input className="form-check-input" type="checkbox" name="affiliatemanagement" value={permissionCheckBox.affiliatemanagement}
                                        checked={permissionCheckBox.affiliatemanagement}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[4] && permissionCheckBox.affiliatemanagement) && "#F97316" }}
                                      >
                                        Affiliate Management
                                      </label>

                                      {permissionCheckBox.affiliatemanagement &&
                                        <FontAwesomeIcon
                                          icon={openMenu[4] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(4)}
                                        />}
                                    </div>

                                    {(openMenu[4] && permissionCheckBox.affiliatemanagement) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="affiliateuser" value={permissionCheckBox.affiliateuser}
                                            checked={permissionCheckBox.affiliateuser}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Affiliate Users</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="affiliatecommonlist" value={permissionCheckBox.affiliatecommonlist}
                                            checked={permissionCheckBox.affiliatecommonlist}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Affiliate Common List</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}

                                    >
                                      <input className="form-check-input" type="checkbox" name="useractivity" value={permissionCheckBox.useractivity}
                                        checked={permissionCheckBox.useractivity}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[5] && permissionCheckBox.useractivity) && "#F97316" }}
                                      >
                                        User Activity
                                      </label>

                                      {permissionCheckBox.useractivity &&
                                        <FontAwesomeIcon
                                          icon={openMenu[5] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(5)}
                                        />}
                                    </div>

                                    {(openMenu[5] && permissionCheckBox.useractivity) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="loginhistory" value={permissionCheckBox.loginhistory}
                                            checked={permissionCheckBox.loginhistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Login History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="signuphistory" value={permissionCheckBox.signuphistory}
                                            checked={permissionCheckBox.signuphistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Signup History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="entityhistory" value={permissionCheckBox.entityhistory}
                                            checked={permissionCheckBox.entityhistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Entity History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="sendorhistory" value={permissionCheckBox.sendorhistory}
                                            checked={permissionCheckBox.sendorhistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Sendor History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="templatehistory" value={permissionCheckBox.templatehistory}
                                            checked={permissionCheckBox.templatehistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Template History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="awssetuphistory" value={permissionCheckBox.awssetuphistory}
                                            checked={permissionCheckBox.awssetuphistory}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">AWS Setup History</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="apirequest" value={permissionCheckBox.apirequest}
                                            checked={permissionCheckBox.apirequest}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">API Request</label>
                                        </div>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="invalidapirequest" value={permissionCheckBox.invalidapirequest}
                                            checked={permissionCheckBox.invalidapirequest}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Invalid API Request</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}

                                    >
                                      <input className="form-check-input" type="checkbox" name="setting" value={permissionCheckBox.setting}
                                        checked={permissionCheckBox.setting}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0, color: (openMenu[8] && permissionCheckBox.setting) && "#F97316" }}
                                      >
                                        Setting
                                      </label>

                                      {permissionCheckBox.setting &&
                                        <FontAwesomeIcon
                                          icon={openMenu[8] ? faChevronDown : faChevronRight}
                                          style={{ fontSize: "12px", color: "#666" }}
                                          onClick={() => toggleMenu(8)}
                                        />}
                                    </div>

                                    {(openMenu[8] && permissionCheckBox.setting) && (
                                      <div style={{ paddingLeft: "22px", marginTop: "6px" }}>
                                        <div className="form-check mb-1">
                                          <input className="form-check-input" type="checkbox" name="resellersetting" value={permissionCheckBox.resellersetting}
                                            checked={permissionCheckBox.resellersetting}
                                            onChange={handlePermissionCheckbox} />
                                          <label className="form-check-label">Reseller Setting</label>
                                        </div>
                                      </div>
                                    )}
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(11)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="billingreport" value={permissionCheckBox.billingreport}
                                        checked={permissionCheckBox.billingreport}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Billing Report
                                      </label>

                                      {permissionCheckBox.billingreport && <>
                                        <input className="form-check-input ml-8" type="checkbox" name="billingreportall" value={permissionCheckBox.billingreportall}
                                          checked={permissionCheckBox.billingreportall}
                                          onChange={handlePermissionCheckbox} />
                                        <label className="form-check-label ml-5">All</label>
                                      </>}
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(13)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="vendorsummary" value={permissionCheckBox.vendorsummary}
                                        checked={permissionCheckBox.vendorsummary}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Vendor Summary
                                      </label>
                                    </div>
                                  </div>


                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(14)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="encrytionsetting" value={permissionCheckBox.encryptionsetting}
                                        checked={permissionCheckBox.encryptionsetting}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Encryption Setting
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(16)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="notificationsetting" value={permissionCheckBox.notificationsetting}
                                        checked={permissionCheckBox.notificationsetting}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Notification Setting
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(17)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="crossorigin" value={permissionCheckBox.crossorigin}
                                        checked={permissionCheckBox.crossorigin}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Cross Origin
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(18)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="addfaq" value={permissionCheckBox.addfaq}
                                        checked={permissionCheckBox.addfaq}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Add FAQ
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(19)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="blog" value={permissionCheckBox.blog}
                                        checked={permissionCheckBox.blog}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Blog
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(20)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="feedback" value={permissionCheckBox.feedback}
                                        checked={permissionCheckBox.feedback}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Feedback
                                      </label>
                                    </div>
                                  </div>

                                  <div className="col-md-3 mb-3">
                                    <div
                                      className="form-check"
                                      style={{
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "6px",
                                      }}
                                      onClick={() => toggleMenu(21)}
                                    >
                                      <input className="form-check-input" type="checkbox" name="contactus" value={permissionCheckBox.contactus}
                                        checked={permissionCheckBox.contactus}
                                        onChange={handlePermissionCheckbox} />

                                      <label
                                        className="form-check-label"
                                        style={{ fontWeight: "500", marginBottom: 0 }}
                                      >
                                        Contact Us
                                      </label>
                                    </div>
                                  </div>

                                </div>

                              </div>
                            </div>}



                          {/* BUTTON */}
                          <div style={{ marginTop: "20px", textAlign: "right" }}>
                            <button
                              type="button"
                              onClick={addNewEmployee}
                              className="btn btn-primary"
                              style={{
                                padding: "8px 25px",
                                borderRadius: "6px"
                              }}
                            >
                              Add
                            </button>
                          </div>

                        </form>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
        <AdminFooter />
      </div>
    </div>
  );
};

export default AddEmployee;
